import React from 'react';
import MacTable from './MacTable';
import '../../styles/findings.css';
import '../../styles/style.css';

const FindingsTable = ({ findings, title }) => {
  const headers = ['Title', 'Severity'];

  // Count findings by severity
  const getSeveritySummary = () => {
    if (!findings || findings.length === 0) return null;
    
    const counts = findings.reduce((acc, finding) => {
      const severity = finding.severity?.toLowerCase() || 'other';
      acc[severity] = (acc[severity] || 0) + 1;
      return acc;
    }, {});
    
    // Order by severity level (critical, high, medium, low, informational)
    const orderedSeverities = ['critical', 'high', 'medium', 'low', 'insight'];
    
    return (

        <div className="findings-summary-counts">
          {orderedSeverities.map(severity => {
            if (counts[severity]) {
              return (
                <span key={severity} className={`severity ${severity}`}>
                  {severity}: {counts[severity]}
                </span>
              );
            }
            return null;
          })}
        </div>
    );
  };

  const renderRow = (item, index) => {
    // Normalize severity to lowercase for consistent styling
    const severityKey = item.severity?.toLowerCase();
    
    return (
      <tr key={item.id || index}>
        <td>{item.findingURL ? (
          <a href={item.findingURL} target="_blank" rel="noopener noreferrer">{item.title}</a> 
        ) : item.title}</td>
        <td>
          <span className={`severity ${severityKey}`}>
            {item.severity}
          </span>
        </td>
      </tr>
    );
  };

  return (
    <div className="findings-table-container">
      {getSeveritySummary()}
      <MacTable
        title={title}
        headers={headers}
        data={findings || []}
        renderRow={renderRow}
      />
    </div>
  );
};

export default React.memo(FindingsTable);
